/* Pop up "dit stukje strand is nog niet af" (1-10-2026). Zie snippets/km-nog-niet.liquid voor wat en waarom.
   Een klik op een link naar een pagina of website die nog niet online mag, toont de pop up in plaats van de pagina. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('km-nno-config');
  var laag = document.querySelector('[data-km-nno-laag]');
  if (!cfgEl || !laag) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  // Zelf de pagina's bekijken terwijl ze nog niet online mogen: voeg ?nno=uit aan een adres toe (blijft voor dit tabblad), ?nno=aan zet het weer aan.
  try {
    var q = new URLSearchParams(location.search).get('nno');
    if (q === 'uit') sessionStorage.setItem('km-nno', 'uit');
    if (q === 'aan') sessionStorage.removeItem('km-nno');
    if (sessionStorage.getItem('km-nno') === 'uit') { document.documentElement.classList.remove('kmnno-direct'); return; }
  } catch (e) {}
  var tekstEl = laag.querySelector('[data-km-nno-tekst]');
  var kopEl = laag.querySelector('[data-km-nno-kop]');
  var terug = null;
  var direct = !!cfg.direct;

  function lijst(a) {
    return (a || []).map(function (x) { return String(x).trim().toLowerCase(); }).filter(Boolean);
  }
  // Welke pop up bij welke website: elk merk in zijn eigen huisstijl.
  var VARIANT = { 'cutiepix.nl': 'cutiepix', 'sprankelkrachten.nl': 'sprankelkrachten', 'rolstoelvoorjebrein.nl': 'rolstoel' };
  var paginas = lijst(cfg.pagina);
  var sites = lijst(cfg.sites);
  // De winkel en wat erbij hoort mag altijd.
  var altijd = ['/collections', '/products', '/cart', '/checkout', '/checkouts', '/account', '/search', '/policies', '/apps', '/tools', '/a', '/gift_cards', '/customer_authentication'];

  // De merksites van Cutiepix, Sprankelkrachten en Rolstoel voor je Brein draaien in hetzelfde thema, via ?merk= in het adres
  // en via hun eigen collecties. Ook die mogen nog niet online.
  var MERK = { 'cutiepix': 'cutiepix', 'sprankelkrachten': 'sprankelkrachten', 'rolstoel-voor-je-brein': 'rolstoel' };
  function merkVan(u) {
    var m = (u.searchParams.get('merk') || '').toLowerCase();
    if (MERK[m]) return MERK[m];
    var c = u.pathname.toLowerCase().match(/^\/collections\/(?:merk-)?(cutiepix|sprankelkrachten|rolstoel-voor-je-brein)(?:$|[-\/])/);
    return c ? MERK[c[1]] : '';
  }
  function soort(href) {
    // Geeft 'pagina', 'cutiepix' of 'site' als de link niet mag, anders leeg.
    var u;
    try { u = new URL(href, location.href); } catch (e) { return ''; }
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return '';
    var host = u.hostname.toLowerCase();
    if (host !== location.hostname.toLowerCase() && !/myshopify\.com$/.test(host)) {
      for (var i = 0; i < sites.length; i++) {
        if (host === sites[i] || host.slice(-(sites[i].length + 1)) === '.' + sites[i]) {
          return VARIANT[sites[i]] || 'site';
        }
      }
      return '';
    }
    var mv = merkVan(u);
    if (mv) return mv;
    var pad = u.pathname.toLowerCase().replace(/\/+$/, '');
    if (pad === '') return '';
    for (var j = 0; j < altijd.length; j++) { if (pad === altijd[j] || pad.indexOf(altijd[j] + '/') === 0) return ''; }
    var m = pad.match(/^\/pages\/([^\/]+)/);
    if (m) return paginas.indexOf(m[1]) > -1 ? '' : 'pagina';
    if (/^\/(blogs|pages)(\/|$)/.test(pad)) return 'pagina';
    return '';
  }

  function toon(variant) {
    // Elk merk zijn eigen sociale media: niet elk merk heeft alles (zie mails/bouw-merkfooters.py).
    var merkNaam = variant === 'rolstoel' ? 'rolstoel' : (variant === 'sprankelkrachten' ? 'sprankelkrachten' : (variant === 'cutiepix' ? 'cutiepix' : ''));
    var standaard = laag.querySelector('[data-km-nno-socials]');
    if (standaard) standaard.hidden = !!merkNaam;
    Array.prototype.forEach.call(laag.querySelectorAll('[data-km-nno-merk]'), function (d) {
      d.hidden = d.getAttribute('data-km-nno-merk') !== merkNaam;
    });
    // Het WhatsApp kanaal: alleen Kaatje&Mup (het venster uit de voettekst) en Cutiepix (rechtstreeks) hebben er een.
    var wa = laag.querySelector('[data-km-nno-proxy="wa"]');
    if (wa) wa.hidden = (merkNaam === 'rolstoel' || merkNaam === 'sprankelkrachten');
    // Bij Cutiepix in de huisstijl van Cutiepix: papier, logo, kleurstreep en roze knoppen.
    ['cutiepix', 'sprankelkrachten', 'rolstoel'].forEach(function (m) { laag.classList.toggle('kmnno--' + m, variant === m); });
    if (kopEl) kopEl.textContent = (cfg.koppen && (cfg.koppen[variant] || cfg.koppen.pagina)) || kopEl.textContent;
    // Een lege regel in de tekst scheidt twee alinea's; een nieuwe regel is een afbreking op een breed scherm
    // (op een telefoon loopt de tekst gewoon door, zonder vaste afbreking).
    tekstEl.textContent = '';
    String(cfg.teksten[variant] || cfg.teksten.pagina).split(/\r?\n\s*\r?\n/).forEach(function (alinea) {
      var p = document.createElement('span');
      p.className = 'kmnno__alinea';
      alinea.split(/\r?\n/).forEach(function (regel, i) {
        if (i) {
          p.appendChild(document.createTextNode(' '));
          var br = document.createElement('br');
          br.className = 'kmnno__br';
          p.appendChild(br);
        }
        p.appendChild(document.createTextNode(regel));
      });
      tekstEl.appendChild(p);
    });
    terug = document.activeElement;
    laag.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var knop = laag.querySelector('[data-km-nno-sluit]');
    if (knop) knop.focus();
  }
  function sluit() {
    laag.hidden = true;
    document.documentElement.style.overflow = '';
    if (direct) { location.href = '/'; return; }
    if (terug && terug.focus) { try { terug.focus(); } catch (e) {} }
  }

  // Dezelfde sociale media icoontjes als in de voettekst, zodat ze nooit uit de pas lopen.
  (function () {
    var doel = laag.querySelector('[data-km-nno-socials]');
    var bron = document.querySelectorAll('.kmvt__socials a');
    if (!doel) return;
    if (!bron.length) { var volg = laag.querySelector('.kmnno__volg'); if (volg) volg.hidden = true; return; }
    Array.prototype.forEach.call(bron, function (a) {
      var k = a.cloneNode(false);
      k.removeAttribute('data-kmvt-open');
      k.removeAttribute('class');
      k.setAttribute('target', '_blank');
      k.setAttribute('rel', 'noopener');
      // Het icoontje als masker, zodat het in de kleur van het merk van deze pop up staat.
      var img = a.querySelector('img');
      var ic = document.createElement('span');
      ic.className = 'kmnno__ic';
      if (img) ic.style.setProperty('--ic', 'url("' + (img.currentSrc || img.src) + '")');
      k.appendChild(ic);
      if (a.getAttribute('title')) k.setAttribute('aria-label', a.getAttribute('title'));
      doel.appendChild(k);
    });
  })();

  // Per merk: naam, waar de nieuwsbrief over gaat en het label (zoals in snippets/km-nieuwsbrief-popup.liquid en km-nieuwsbrieflabels).
  var NIEUWSBRIEF = {
    cutiepix: { naam: 'Cutiepix', label: 'nieuwsbrief-cutiepix', over: 'nieuwe pixelsets, wat er bij komt en waar je ons kunt vinden' },
    sprankelkrachten: { naam: 'Sprankelkrachten', label: 'nieuwsbrief-sprankelkrachten', over: 'waar we optreden, wat er nieuw is en waar we mee bezig zijn' },
    rolstoel: { naam: 'Rolstoel voor je brein', label: 'nieuwsbrief-rolstoel', over: 'een nieuw boek of hulpmiddel en wat we erover te vertellen hebben' }
  };
  function merkNieuwsbrief(laag) {
    var m = ['cutiepix', 'sprankelkrachten', 'rolstoel'].filter(function (x) { return laag.classList.contains('kmnno--' + x); })[0];
    var pop = document.getElementById('kmPop');
    if (!m || !pop) return false;
    var nb = NIEUWSBRIEF[m];
    var titel = pop.querySelector('#kmPopTitel');
    var tekst = pop.querySelector('.km-pop__tekst');
    var klein = pop.querySelector('.km-pop__klein');
    var veld = pop.querySelector('input[name="contact[tags]"]');
    var kanaal = pop.querySelector('.km-kanaal');
    // Eerst onthouden hoe het venster er van Kaatje&Mup uitziet: de voettekst gebruikt hetzelfde venster en moet dat weer terugkrijgen.
    if (!pop._kmnnoOrigineel) {
      pop._kmnnoOrigineel = { titel: titel && titel.textContent, tekst: tekst && tekst.textContent, klein: klein && klein.textContent, tags: veld && veld.value, kanaal: kanaal && kanaal.outerHTML };
      new MutationObserver(function () {
        if (!pop.hidden) return;
        var o = pop._kmnnoOrigineel;
        if (titel) titel.textContent = o.titel;
        if (tekst) tekst.textContent = o.tekst;
        if (klein) klein.textContent = o.klein;
        if (veld) veld.value = o.tags;
        var nu = pop.querySelector('.km-kanaal');
        if (nu && o.kanaal) { var t = document.createElement('div'); t.innerHTML = o.kanaal; nu.replaceWith(t.firstElementChild); }
      }).observe(pop, { attributes: true, attributeFilter: ['hidden'] });
    }
    if (titel) titel.textContent = 'Zullen we je de nieuwsbrief van ' + nb.naam + ' sturen?';
    if (tekst) tekst.textContent = 'We sturen niet vaak een nieuwsbrief, echt niet vaak. Maar als er eentje komt, is het er eentje om even bij te gaan zitten: ' + nb.over + '.';
    if (klein) klein.textContent = 'Je krijgt de nieuwsbrief van ' + nb.naam + '. Afmelden kan altijd, met één klik onderaan elke mail.';
    if (veld) veld.value = 'nieuwsbrief, ' + nb.label;
    // Het WhatsApp kanaal onderaan: alleen Cutiepix heeft er een eigen (Rolstoel voor je Brein en Sprankelkrachten niet).
    if (kanaal) {
      kanaal.style.display = (m !== 'cutiepix') ? 'none' : '';
      var knop = kanaal.querySelector('.km-kanaal__knop');
      if (knop && m === 'cutiepix') {
        knop.setAttribute('href', 'https://whatsapp.com/channel/0029VbDhOX9DJ6GzxQrkvI12');
        Array.prototype.forEach.call(knop.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ' Cutiepix '; });
      }
    }
    laag.hidden = true;
    document.documentElement.style.overflow = '';
    pop.hidden = false;
    document.body.style.overflow = 'hidden';
    var mail = document.getElementById('kmPopMail'); if (mail) mail.focus();
    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented && !e.target.closest('[data-km-nno]')) return;
    if (e.target.closest('.kmnno')) {
      if (e.target.closest('[data-km-nno-sluit]') || e.target === laag) { e.preventDefault(); sluit(); return; }
      // De nieuwsbrief en het WhatsApp kanaal staan achter een klik in de voettekst: dit venster sluit en die opent.
      var proxy = e.target.closest('[data-km-nno-proxy]');
      if (proxy) {
        e.preventDefault();
        // Bij Cutiepix gaat het WhatsApp kanaal rechtstreeks naar het kanaal van Cutiepix.
        if (proxy.getAttribute('data-km-nno-proxy') === 'wa' && laag.classList.contains('kmnno--cutiepix')) {
          window.open(proxy.getAttribute('data-km-nno-kanaal'), '_blank', 'noopener');
          return;
        }
        // De nieuwsbrief van een merk: het aanmeldvenster dat er al is (km-nieuwsbrief-popup), met de tekst en het label van dat merk.
        if (proxy.getAttribute('data-km-nno-proxy') === 'kaart' && merkNieuwsbrief(laag)) return;
        var voet = document.querySelector('.kmvt [data-kmvt-open="' + proxy.getAttribute('data-km-nno-proxy') + '"]');
        laag.hidden = true;
        document.documentElement.style.overflow = '';
        if (voet) voet.click();
      }
      return;
    }
    // Een knop die een eigen pop up opent (zoals Over Cutiepix) en nog niet mag.
    var knop = e.target.closest('[data-km-nno]');
    if (knop) {
      e.preventDefault();
      e.stopImmediatePropagation();
      toon(knop.getAttribute('data-km-nno') || 'cutiepix');
      return;
    }
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a) return;
    // De links naar de andere merken in de voettekst gaan gewoon door, de merksites hebben nu een eigen beginscherm (4-10-2026,
    // Carolien: "in de footer bij de links van de andere merken website's mag je de popups weghalen. zowel op mobiel als de desktop versie").
    if (a.closest('[data-km-nno-vrij]')) return;
    var v = soort(a.getAttribute('href'));
    if (!v) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    toon(v);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !laag.hidden) sluit();
  });

  // Rechtstreeks geopend: een pagina die nog niet mag (zie de snippet), of een merksite.
  var eigen = '';
  try { eigen = merkVan(new URL(location.href)); } catch (e) {}
  if (eigen) direct = true;
  if (direct) {
    document.documentElement.classList.add('kmnno-direct');
    toon(eigen || 'pagina');
  }
})();
